/// <reference path='../../../../../typings/index.d.ts' />
/// <reference path='../controls.module.ts' />

module Meevo.Components.Controls {
    'use strict';

    class MeevoAiTextArea implements angular.IComponentController {
        static scriptLoadPromise: Promise<void> | null = null;
        ngModel: string;
        category: string;
        contentKey: string;
        subject: string;
        height: string;
        charLimit: number;
        ngDisabled: boolean;
        ngRequired: boolean;
        wizard: string;
        embedSrc: string;
        useFallback: boolean = false;
        private meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        constructor(private $sce: angular.ISCEService, 
            private $element: angular.IAugmentedJQuery, 
            private $scope: angular.IScope, 
            private $timeout: angular.ITimeoutService,
            private securityService: Meevo.Components.Common.ISecurityService) {

        }

        static $inject = [
            '$sce',
            '$element',
            '$scope',
            '$timeout',
            'meevo.components.common.SecurityService'
        ];

        $onInit() {
            this.securityService.checkSecurityKey(`${this.meevoSecurityKeys.MEEVOAITEXTAREA}:READ`).then((permission) => {
                if (permission !== Meevo.Model.SecurityAccessEnum.Grant) {
                    this.loadLegacyTextarea();
                } else {
                    this.loadMeevoAiTextarea();
                }
            }
            ).catch(() => {
                this.loadLegacyTextarea();
            });
        }

        $onChanges() {
            if (!this.useFallback) {
                this.updateElement();
            }
        }

        loadLegacyTextarea() : void {
            this.useFallback = true;
            this.$scope.$apply();
        }

        loadMeevoAiTextarea() : void {
            this.loadScript()
                .then(() => {
                    this.embedSrc = this.getSrcdoc();
                    this.attachEventListener();
                })
                .catch((error) => {
                    this.loadLegacyTextarea();
                });
        }

        loadScript(): Promise<void> {
            if (!MeevoAiTextArea.scriptLoadPromise) {
                MeevoAiTextArea.scriptLoadPromise = new Promise<void>((resolve, reject) => {
                    const version = sessionStorage.getItem("mil:meevo:aiversion") || new Date().toISOString().split('T')[0];
                    const scriptSrc = `${window['MeevoAIMicroserviceUrl'] || ''}/assets/meevo-ai-textarea.js?v=${version}`;
    
                    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
                    if (existingScript) {
                        resolve();
                        return;
                    }
    
                    const script = document.createElement('script');
                    script.src = scriptSrc;
                    script.async = true;
                    script.onload = () => {
                        resolve();
                    };
                    script.onerror = (error) => {
                        reject(error);
                    };
                    document.head.appendChild(script);
                });
            }
            return MeevoAiTextArea.scriptLoadPromise;
        }

        attachEventListener() {
            this.$timeout(() => {
                const element = this.$element[0].querySelector('div > meevo-ai-textarea');
                if (element) {
                    element.addEventListener('valueChanged', this.onValueChanged.bind(this));
                } else {
                    this.attachEventListener();
                }
            }, 100);
        }

        updateElement() {
            const element = this.$element[0].querySelector('meevo-ai-textarea');
            if (element) {
                element.setAttribute('value', this.ngModel || '');
                element.setAttribute('disabled', this.ngDisabled.toString());
                element.setAttribute('subject', this.subject);
            }
        }

        onValueChanged(event: CustomEvent) {
            if (!event || event.detail === undefined || event.detail === null) return;
            this.ngModel = event.detail;
            this.$scope.$apply();
        }

        getSrcdoc(): string {
            let baseUrl = window['MeevoAIMicroserviceUrl'] || '';
            let escapeValue = (value: string): string => {
                return (value || '')
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;');
            };
            let srcdoc = `<meevo-ai-textarea
                    api='${escapeValue(baseUrl)}'
                    value='${escapeValue(this.ngModel) || ''}'
                    height='${this.height || 200}'
                    maxlength='${this.charLimit || 9999}'
                    wizard='${this.wizard || false}'
                    disabled='${this.ngDisabled}'
                    label='${escapeValue(this.contentKey)}'
                    category='${escapeValue(this.category)}'
                    subject='${escapeValue(this.subject)}'
                    >
                </meevo-ai-textarea>`;
            return this.$sce.trustAsHtml(srcdoc);
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoAiTextArea', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/aiTextArea/aiTextArea.component.html',
            controller: MeevoAiTextArea,
            controllerAs: 'vm',
            bindings: {
                ngModel: '=',
                charLimit: '<',
                wizard: '<',
                category: '<',
                subject: '<',
                ngDisabled: '<',
                ngRequired: '<',
                contentKey: '<',
                height: '<'
            }
        });

}